// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__EApLL","rootSuccess":"CompleteLink_rootSuccess__1avHN","rootFailure":"CompleteLink_rootFailure__6EbIG","isDisabled":"CompleteLink_isDisabled__39q53"};